import { DateTime } from 'luxon';

import { DatesService } from '@common/services';

import { ScheduleDescriptionApi } from '../../api/models';

export class ScheduleDescription
{
    hour?: number;
    hours: number[];
    weekDays?: number[];
    monthDays?: number[];
    periodicity: number;
    predefInterval: number;
    scheduleValue: number;
    scheduleType: number;
    winterTime: boolean;
    intervalType: number;
    lastScheduleUTC: DateTime;
    nextScheduleUTC: DateTime;
    tickIndex: number;

    public static mapperFromApi (source: ScheduleDescriptionApi): ScheduleDescription
    {
        const target = new ScheduleDescription();

        Object.assign(target, source);

        target.lastScheduleUTC = DatesService.UtcStringToDateTimeHourStatic(source.lastScheduleUTC);
        target.nextScheduleUTC = DatesService.UtcStringToDateTimeHourStatic(source.nextScheduleUTC);

        return target;
    }

    public static mapperToApi (source: ScheduleDescription): ScheduleDescriptionApi
    {
        const target = new ScheduleDescriptionApi();

        Object.assign(target, source);

        target.lastScheduleUTC = source.lastScheduleUTC.toISO();

        return target;
    }
}
